module.exports = __webpack_public_path__ + "img/folder.d40e8ad8.svg";